function objectHasAllKeys(required) {
	return (obj) => {
		const objKeys = Object.keys(obj);
		return required.every((key) => objKeys.includes(key));
	};
}

function arrayObjectsHaveAllKeys(required) {
	return (array) => array.every(objectHasAllKeys(required));
}

function isOneOf(values) {
	return (value) => values.includes(value);
}

function allObjectValuesAreNumbers(obj) {
	return Object.values(obj).every((value) => typeof value === 'number');
}

export { isOneOf };
export { objectHasAllKeys };
export { arrayObjectsHaveAllKeys };
export { allObjectValuesAreNumbers };
